import { render, staticRenderFns } from "./HotTopics.vue?vue&type=template&id=0c9f7170&scoped=true"
import script from "./HotTopics.vue?vue&type=script&lang=js"
export * from "./HotTopics.vue?vue&type=script&lang=js"
import style0 from "./HotTopics.vue?vue&type=style&index=0&id=0c9f7170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9f7170",
  null
  
)

export default component.exports